<template>
	<nav class="light-nav-buttons">
		<component
			v-for="navItem in navItems"
			:key="navItem.text"
			:is="navItem.action ? 'button' : 'router-link'"
			v-bind="navItemBindings(navItem)"
			class="light-nav-btn"
			:class="{'active': isNavItemActive(navItem)}"
			v-on:click="navItemClicked(navItem)">
			<span class="light-nav-btn-icon" :style="{backgroundColor: navItem.backgroundColor}">
				<i class="fa" :class="navItem.icon"></i>
			</span>
			<span class="light-nav-btn-label">{{ navItem.text }}</span>
			<span class="light-nav-btn-active-line"></span>
		</component>

		<job-photo-uploader
			v-if="jobType == 'service' && jobId"
			ref="photoUploader"
			class="light-nav-photo-uploader"
			store-location="service"
			:job-id="jobId">
		</job-photo-uploader>
	</nav>
</template>

<script type="text/javascript">
import JobPhotoUploader from "@/components/super_components/JobPhotoUploader"

export default {
	name: "LightNavButtons",
	components: {
		JobPhotoUploader
	},
	props: ['moduleBaseUrl', 'jobType'],
	computed: {
		jobId() {
			if (this.jobType == 'service' && this.$store.service && 'id' in this.$store.service)
				return this.$store.service.id

			return null
		},
		navItems() {
			let items = [
				{
					icon: 'fa-tachometer-alt',
					text: 'Dashboard',
					link: this.moduleBaseUrl + 'dashboard',
					backgroundColor: '#1e8449'
				}
			]

			if (this.jobType == 'service') {
				items.push({
					icon: 'fa-wrench',
					text: 'Worksheet',
					link: this.moduleBaseUrl + 'worksheet',
					backgroundColor: '#1e8449'
				})
			}

			items.push({
				icon: 'fa-file-image',
				text: 'Files',
				link: this.moduleBaseUrl + 'files',
				backgroundColor: '#216ce7'
			})

			if (this.jobType == 'service') {
				items.push({
					icon: 'fa-camera',
					text: 'Take Photo',
					action: 'takePhoto',
					backgroundColor: '#216ce7'
				})
			}

			items.push({
				icon: 'fa-clipboard-check',
				text: 'Do Form',
				action: 'doCompanyForm',
				backgroundColor: '#2e10a3'
			})

			return items
		}
	},
	methods: {
		navItemBindings(navItem) {
			if (navItem.action)
				return {type: 'button'}

			return {to: navItem.link}
		},
		navItemClicked(navItem) {
			if (navItem.action)
				this[navItem.action]()
		},
		isNavItemActive(navItem) {
			if (!navItem.link || navItem.link == '#')
				return false

			if (this.$route.path == navItem.link)
				return true

			if (this.$route.path.indexOf(navItem.link + '/') == 0)
				return true

			return false
		},
		doCompanyForm() {
			if (this.jobType == 'service')
				this.$bus.$emit("doCompanyForm", {service_id: this.$store.service.id})
			else
				this.$bus.$emit("doCompanyForm", {job_id: this.$store.project.id})
		},
		takePhoto() {
			let uploader = this.$refs.photoUploader
			if (!uploader)
				return

			let fileInput = uploader.$el.querySelector('input[type=file]')
			if (fileInput)
				fileInput.click()
		}
	}
}
</script>

<style scoped>
.light-nav-buttons {
	display: flex;
	flex-wrap: nowrap;
	justify-content: space-around;
	align-items: flex-start;
	gap: 0.25rem;
	padding: 0.25rem 0 0;
}

.light-nav-btn {
	display: flex;
	flex-direction: column;
	align-items: center;
	box-sizing: border-box;
	flex: 1 1 0;
	min-width: 0;
	padding: 0 0.15rem;
	border: 0;
	background: transparent;
	text-decoration: none;
	color: #1a2332;
	cursor: pointer;
}

.light-nav-btn:hover {
	text-decoration: none;
	color: #1a2332;
	opacity: 0.88;
}

.light-nav-btn-icon {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 2.85rem;
	height: 2.85rem;
	border-radius: 50%;
	color: #fff;
	font-size: 1.15rem;
	margin-bottom: 0.3rem;
}

.light-nav-btn-label {
	font-size: 0.7rem;
	font-weight: 700;
	line-height: 1.15;
	text-align: center;
}

.light-nav-btn-active-line {
	display: block;
	width: 100%;
	height: 3px;
	margin-top: 0.35rem;
	background-color: transparent;
	border-radius: 2px;
}

.light-nav-btn.active .light-nav-btn-active-line {
	background-color: var(--brand-primary-color);
}

.light-nav-photo-uploader >>> .file-drop {
	position: absolute;
	width: 0;
	height: 0;
	overflow: hidden;
	opacity: 0;
	pointer-events: none;
}
</style>
